import React, { useMemo } from 'react';
import { Card, DatePickerInput, Dropdown, DropdownTheme } from 'wix-ui-tpa/cssVars';
import { dataHooks } from '@wix/data-hooks';
import { classes } from './TimeSlotSelector.st.css';
import { useDeliverySectionData } from '../../../provider/useDeliverySectionContext';
import { dateKeyFromDate } from '../../../utils/dateTimeUtils';
import { useLocaleKeys } from '../../../locale-keys/LocaleKeys';
export const TimeSlotSelectorHook = dataHooks('TimeSlotSelector');
export const TimeSlotSelector = props => {
  const {
    deliveryOption
  } = props;
  const {
    locale,
    setDeliveryMethodId,
    selectedDeliveryOption,
    isUpdatingShippingOption
  } = useDeliverySectionData();
  const localeKeys = useLocaleKeys();
  const {
    deliveryTimeSlots,
    selectedDay
  } = useMemo(() => {
    let calculatedSelectedDay = '';
    const mappedDeliveryTimeSlots = deliveryOption.options.reduce((acc, option) => {
      if (!option.dateKey || !option.timeString) {
        return acc;
      }
      if ((selectedDeliveryOption == null ? void 0 : selectedDeliveryOption.id) === option.id) {
        calculatedSelectedDay = option.dateKey;
      }
      if (!acc[option.dateKey]) {
        acc[option.dateKey] = [];
      }
      acc[option.dateKey].push({
        id: option.id,
        value: option.timeString,
        isSelectable: true
      });
      return acc;
    }, {});
    return {
      selectedDay: calculatedSelectedDay,
      deliveryTimeSlots: mappedDeliveryTimeSlots
    };
  }, [deliveryOption.options, selectedDeliveryOption == null ? void 0 : selectedDeliveryOption.id]);
  const hasOnlyOneDateAvailable = useMemo(() => Object.keys(deliveryTimeSlots).length === 1, [deliveryTimeSlots]);
  const datePickerLocale = useMemo(() => locale ?? /* istanbul ignore next */'en', [locale]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Card, {
    "data-hook": TimeSlotSelectorHook.root(),
    className: classes.dateTimePicker
  }, /*#__PURE__*/React.createElement(DatePickerInput, {
    locale: datePickerLocale,
    inputWidth: "",
    label: localeKeys.deliverySection.date.label(),
    className: classes.date,
    disabled: isUpdatingShippingOption || hasOnlyOneDateAvailable,
    value: new Date(selectedDay),
    onChange: /* istanbul ignore next */date => {
      var _deliveryTimeSlots$da;
      setDeliveryMethodId((_deliveryTimeSlots$da = deliveryTimeSlots[dateKeyFromDate(date)]) == null || (_deliveryTimeSlots$da = _deliveryTimeSlots$da[0]) == null ? void 0 : _deliveryTimeSlots$da.id, deliveryOption.groupId);
    },
    filterDate: /* istanbul ignore next */date => Boolean(deliveryTimeSlots[dateKeyFromDate(date)]),
    removeClearButton: true,
    "data-hook": TimeSlotSelectorHook.calendarDropdown()
  }), /*#__PURE__*/React.createElement(Dropdown, {
    key: selectedDay,
    "data-hook": TimeSlotSelectorHook.timePickerDropdown(),
    className: classes.time,
    label: localeKeys.deliverySection.time.label(),
    upgrade: true,
    theme: DropdownTheme.Box,
    disabled: isUpdatingShippingOption,
    initialSelectedId: selectedDeliveryOption == null ? void 0 : selectedDeliveryOption.id,
    options: deliveryTimeSlots[selectedDay],
    onChange: option => setDeliveryMethodId(option.id, deliveryOption.groupId)
  })));
};
//# sourceMappingURL=TimeSlotSelector.js.map